export const LOCUTIONS_GRECQUES = [{
        id: 1,
        locutionsGrecques: "Connais-toi toi-même (Gnothi seauton)",
        signification: "Prendre conscience de ses propres limites, de sa nature humaine et de sa propre intériorité.",
        origine: "Maxime gravée au fronton du temple de Delphes, reprise par Socrate"
    },
    {
        id: 2,
        locutionsGrecques: "Eurêka",
        signification: "Cri de joie poussé lors d'une découverte soudaine ou de la résolution d'un problème complexe.",
        origine: "Archimède sortant de son bain après avoir trouvé les lois de l'hydrostatique"
    },
    {
        id: 3,
        locutionsGrecques: "Je sais que je ne sais rien",
        signification: "Principe fondamental de la démarche philosophique : reconnaître son ignorance pour pouvoir apprendre.",
        origine: "Socrate (rapporté par Platon dans l'Apologie de Socrate)"
    },
    {
        id: 4,
        locutionsGrecques: "Panta rhei (Tout coule)",
        signification: "Concept stipulant que le monde est en mouvement perpétuel et que rien ne reste figé.",
        origine: "Philosophie présocratique d'Héraclite d'Éphèse"
    },
    {
        id: 5,
        locutionsGrecques: "L'homme est un animal politique (Zoon politikon)",
        signification: "L'être humain est fait par nature pour vivre en société et participer à la vie de la cité.",
        origine: "Aristote dans son traité intitulé La Politique"
    },
    {
        id: 6,
        locutionsGrecques: "L'homme est la mesure de toute chose",
        signification: "La vérité et la réalité dépendent de la perception et de l'interprétation subjective de l'homme.",
        origine: "Maxime du philosophe sophiste Protagoras"
    },
    {
        id: 7,
        locutionsGrecques: "Le juste milieu (Mèden agan / Rien de trop)",
        signification: "Recherche de la modération et refus des extrêmes pour atteindre l'équilibre.",
        origine: "Sagesse antique (Inscrit au temple de Delphes et théorisé par Aristote)"
    },
    {
        id: 8,
        locutionsGrecques: "L'hubris",
        signification: "L'orgueil démesuré, la démesure qui pousse l'homme à défier l'ordre établi et mène à sa perte.",
        origine: "Tragédie grecque et mythologie (Crime suprême puni par la Némésis)"
    },
    {
        id: 9,
        locutionsGrecques: "Kairos",
        signification: "Le moment opportun, la fenêtre de tir idéale qu'il faut saisir au vol pour réussir une action.",
        origine: "Mythologie grecque (Divinité du temps opportun personnifiée par une mèche)"
    },
    {
        id: 10,
        locutionsGrecques: "La catharsis",
        signification: "Épuration des passions (terreur, pitié) chez le spectateur à travers le spectacle dramatique.",
        origine: "Théâtre et philosophie grecque (Aristote dans La Poétique)"
    },
    {
        id: 11,
        locutionsGrecques: "L'ataraxie",
        signification: "État de paix de l'âme et d'indifférence totale face aux troubles extérieurs.",
        origine: "Philosophie hellénistique (Épicuriens, Stoïciens et Sceptiques)"
    },
    {
        id: 12,
        locutionsGrecques: "L'allégorie de la caverne",
        signification: "Métaphore illustrant l'accès difficile des hommes à la connaissance, souvent prisonniers des illusions.",
        origine: "Platon dans le Livre VII de La République"
    },
    {
        id: 13,
        locutionsGrecques: "L'Âge d'or",
        signification: "Période mythique et idéale de bonheur parfait, d'égalité et de paix absolue.",
        origine: "Hésiode dans son poème Les Travaux et les Jours"
    },
    {
        id: 14,
        locutionsGrecques: "Panem et circenses (Du pain et des jeux)",
        signification: "Stratégie politique visant à divertir le peuple pour lui faire oublier ses droits et devoirs.",
        origine: "Concept de la politique des cités grecques, popularisé plus tard en latin"
    },
    {
        id: 15,
        locutionsGrecques: "Un esprit sain dans un corps sain",
        signification: "Idéal de vie combinant l'entraînement intellectuel et le développement physique.",
        origine: "Idéal éducatif grec de la Paideia (repris plus tard par Juvénal)"
    },
    {
        id: 16,
        locutionsGrecques: "Nunc est bibendum (C'est maintenant qu'il faut boire)",
        signification: "Invitation pressante à célébrer une grande victoire ou une excellente nouvelle.",
        origine: "Traduction d'un vers du poète grec Alcée célébrant la chute d'un tyran"
    },
    {
        id: 17,
        locutionsGrecques: "Le sort en est jeté (Alea jacta est / Anerrhiphthô kubos)",
        signification: "Prendre une décision irréversible de laquelle dépend l'avenir.",
        origine: "Prononcé à l'origine en grec par Jules César en franchissant le Rubicon, d'après Ménandre"
    },
    {
        id: 18,
        locutionsGrecques: "Le phénix renaît de ses cendres",
        signification: "Symbole de résilience, de reconstruction ou de retour en force après un désastre total.",
        origine: "Mythologie grecque (Oiseau fabuleux d'Égypte décrit par Hérodote)"
    },
    {
        id: 19,
        locutionsGrecques: "Platon m'est cher, mais la vérité m'est plus chère encore",
        signification: "L'honnêteté intellectuelle et la recherche du vrai doivent primer sur l'amitié ou l'admiration.",
        origine: "Aristote remettant en cause l'enseignement de son maître Platon"
    },
    {
        id: 20,
        locutionsGrecques: "Ostracisme",
        signification: "Exclure quelqu'un d'un groupe ou de la société de manière délibérée.",
        origine: "Athènes antique (Vote de bannissement politique écrit sur des morceaux de poterie)"
    },
    {
        id: 21,
        locutionsGrecques: "L'apathie (Apatheia)",
        signification: "Absence de passions ou de souffrances, recherchée pour obtenir la liberté de l'esprit.",
        origine: "Philosophie stoïcienne (Zénon de Kition, Épictète)"
    },
    {
        id: 22,
        locutionsGrecques: "L'épochè (Suspension du jugement)",
        signification: "Fait de ne pas se prononcer sur une vérité absolue pour préserver la paix de l'esprit.",
        origine: "Philosophie sceptique (Pyrrhon d'Élis)"
    },
    {
        id: 23,
        locutionsGrecques: "Kalos kagathos (Beau et bon)",
        signification: "Idéal grec incarnant la perfection morale alliée à la beauté physique.",
        origine: "Aristocratie athénienne classique du Ve siècle av. J.-C."
    },
    {
        id: 24,
        locutionsGrecques: "L'aporie",
        signification: "Une contradiction logique ou une impasse intellectuelle insoluble.",
        origine: "Dialogues socratiques de Platon où la discussion n'aboutit à aucune définition définitive"
    },
    {
        id: 25,
        locutionsGrecques: "Le Démiurge",
        signification: "Force ou entité créatrice et organisatrice de l'univers matériel.",
        origine: "Cosmologie platonicienne (Dialogue du Timée de Platon)"
    },
    {
        id: 26,
        locutionsGrecques: "Le Monde des Idées",
        signification: "Concept selon lequel le monde sensible n'est qu'un reflet imparfait d'un monde supérieur d'essences pures.",
        origine: "Théorie des Formes de Platon"
    },
    {
        id: 27,
        locutionsGrecques: "Le premier moteur immobile",
        signification: "La cause première de tout mouvement dans l'univers, qui bouge sans être elle-même mue.",
        origine: "Métaphysique d'Aristote"
    },
    {
        id: 28,
        locutionsGrecques: "La maïeutique",
        signification: "L'art d'accoucher les esprits pour faire découvrir aux individus les vérités qu'ils portent en eux.",
        origine: "Méthode de dialogue philosophique employée par Socrate"
    },
    {
        id: 29,
        locutionsGrecques: "Carpe diem (Profite du jour présent)",
        signification: "Invitation à vivre l'instant présent sans se soucier du lendemain.",
        origine: "Philosophie hellénistique (Concept épicurien traduit plus tard par Horace)"
    },
    {
        id: 30,
        locutionsGrecques: "L'Anabase",
        signification: "Une expédition militaire difficile menée depuis la côte vers l'intérieur d'un territoire ennemi.",
        origine: "Œuvre historique de l'écrivain et général grec Xénophon"
    },
    {
        id: 31,
        locutionsGrecques: "L'hédonisme",
        signification: "Doctrine philosophique qui fait du plaisir le but suprême et le principe de la vie.",
        origine: "Philosophie grecque (École cyrénaïque d'Aristippe de Cyrène)"
    },
    {
        id: 32,
        locutionsGrecques: "Le cynisme",
        signification: "Doctrine prônant le mépris des conventions sociales, de la richesse et le retour à la nature.",
        origine: "Diogène de Sinope (vivant nu dans un tonneau à Athènes)"
    },
    {
        id: 33,
        locutionsGrecques: "Le stoïcisme",
        signification: "Philosophie axée sur le contrôle de soi, l'acceptation du destin et la force face à l'adversité.",
        origine: "Zénon de Kition enseignant sous le Portique (Stoa) à Athènes"
    },
    {
        id: 34,
        locutionsGrecques: "L'euthanasie (Au sens antique)",
        signification: "Le fait de mourir d'une mort douce, honorable et digne, sans souffrance prolongée.",
        origine: "Grèce classique (Du grec 'eu' : bon, et 'thanatos' : mort)"
    },
    {
        id: 35,
        locutionsGrecques: "L'homo mensura",
        signification: "Formulation condensée indiquant que l'homme est le seul juge de la vérité des choses.",
        origine: "Thèse relativiste énoncée par le sophiste Protagoras"
    },
    {
        id: 36,
        locutionsGrecques: "Le cosmopolitisme",
        signification: "Se considérer comme un citoyen du monde entier plutôt que d'une seule nation ou cité.",
        origine: "Formulé pour la première fois par Diogène le Cynique"
    },
    {
        id: 37,
        locutionsGrecques: "L'enthousiasme (Entheos)",
        signification: "État de transport divin, d'inspiration ou de ferveur extraordinaire.",
        origine: "Du grec 'en-theos' (avoir le dieu en soi), lié aux cultes dionysiaques"
    },
    {
        id: 38,
        locutionsGrecques: "L'autarcie (Autarkeia)",
        signification: "Fait de se suffire à soi-même et de ne dépendre de personne pour assurer son bonheur.",
        origine: "Idéal économique et moral des cyniques et des stoïciens"
    },
    {
        id: 39,
        locutionsGrecques: "Philia",
        signification: "L'amour bienveillant, l'amitié profonde et réciproque indispensable au bonheur social.",
        origine: "Éthique à Nicomaque d'Aristote"
    },
    {
        id: 40,
        locutionsGrecques: "Agapé",
        signification: "L'amour désintéressé, universel, spirituel et inconditionnel d'autrui.",
        origine: "Grèce antique (Plus tard repris massivement dans la philosophie chrétienne)"
    },
    {
        id: 41,
        locutionsGrecques: "L'égalitarisme (Isonomia)",

        signification: "L'égalité des citoyens devant la loi, principe fondateur du système démocratique.",
        origine: "Réformes démocratiques de Clisthène à Athènes (508 av. J.-C.)"
    },
    {
        id: 42,
        locutionsGrecques: "Parpillage (Polupragmosune)",
        signification: "Le fait de s'immiscer partout, de s'occuper des affaires d'autrui au détriment des siennes.",
        origine: "Philosophie politique (Dénoncé par Platon dans La République)"
    },
    {
        id: 43,
        locutionsGrecques: "L'allégorie du navire",
        signification: "Métaphore comparant la gouvernance d'un État au pilotage complexe d'un navire de guerre.",
        origine: "Platon critiquant la démocratie populaire directe"
    },
    {
        id: 44,
        locutionsGrecques: "L'Esprit des Lois (Nomos)",
        signification: "Le respect des lois humaines perçues comme l'ordre rationnel et protecteur de la communauté.",
        origine: "Philosophie politique d'Athènes au siècle de Périclès"
    },
    {
        id: 45,
        locutionsGrecques: "Le tyran éclairé",
        signification: "Idéal politique d'un dirigeant doté d'un pouvoir absolu mais guidé exclusivement par la sagesse.",
        origine: "Le concept du 'Philosophe Roi' développé par Platon"
    },
    {
        id: 46,
        locutionsGrecques: "L'école péripatéticienne",
        signification: "Philosophie qui s'enseigne et se transmet en marchant en groupe.",
        origine: "Aristote donnant ses cours en se promenant dans les allées du Lycée"
    },
    {
        id: 47,
        locutionsGrecques: "L'anamnèse",
        signification: "La rémanence ou la réminiscence des connaissances oubliées que l'âme possédait avant de s'incarner.",
        origine: "Théorie de la connaissance de Platon (Dialogue du Ménon)"
    },
    {
        id: 48,
        locutionsGrecques: "La Mimésis",
        signification: "L'imitation artistique de la nature et de la réalité par l'écrivain, le peintre ou l'acteur.",
        origine: "Concept clé de l'esthétique classique défini par Platon et Aristote"
    },
    {
        id: 49,
        locutionsGrecques: "Le paradoxe de la flèche",
        signification: "Démonstration logique prétendant prouver que le mouvement physique est une illusion de l'esprit.",
        origine: "Paradoxes célèbres du philosophe Zénon d'Élée"
    },
    {
        id: 50,
        locutionsGrecques: "L'Arpenteur de l'univers",
        signification: "Surnom élogieux attribué aux mathématiciens capables de mesurer la Terre avec de simples outils géométriques.",
        origine: "Travaux d'Ératosthène ayant calculé la circonférence terrestre au IIIe siècle av. J.-C."
    }
];